export default "__VITE_ASSET__BA6xr27u__"